import * as React from 'react'

import { BaseIcon/*, Props*/ } from './BaseIcon'

export class Home extends BaseIcon {
  /*constructor (props: Props) {
    super(props)
  }*/

  render () {
  const className = this.props.className ? `${this.defaults.className} ${this.getSize()} ${this.props.className}`
      : `${this.defaults.className} ${this.getSize()}`

    //const viewBox = this.props.viewBox ? this.props.viewBox : this.defaults.viewBox

    // tslint:disable    
    return (
        <div>
          <svg className={className} viewBox="0 -960 960 960"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"/></svg>
        </div>
      )
  }
}
export default Home
